import React, { useCallback, useEffect, useState } from "react";
import Map from "./components/Map";
import { fetchBottleData } from "./util/fetchBottleData";
import L from "leaflet";
import { convertToGeoJSON } from "./util/functions";
import _ from "lodash";
import { colors } from "./util/constants";

import { Rogue1_SL_BR } from "./data/Rouge1Geojson";

const Rogue1Line = JSON.parse(Rogue1_SL_BR);

const tagMap = {
  Rogue1: {
    order: 1,
    name: "Bottle 1",
    color: colors.orange,
  },
  Rogue2: {
    order: 2,
    name: "Bottle 2",
    color: colors.blue,
  },
  BOTTLE11: {
    order: 3,
    name: "Bottle 3",
    color: colors.lightBlue,
  },
  Rogue3: {
    order: 4,
    name: "Bottle 4",
    color: colors.offBlue,
  },
};

const BottleMap = () => {
  const [bottleData, setBottleData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const splitByTrack = (group: any) => {
    console.log(group);
    let result = [];
    let curr_group: any = undefined;
    group.forEach((tag: any, i: number) => {
      if (tag.status === "DEPLOY") {
        curr_group && curr_group.length > 0 && result.push(curr_group);
        curr_group = [tag];
      } else {
        curr_group.push(tag);
      }
    });
    curr_group.length > 0 && result.push(curr_group);
    return result;
  };

  const addBottleToMap = (map: L.Map, bottleData: any[]) => {
    // make the bottle array more sparse - filter every 5th "track" points
    // reorder to push start and stop point to back
    // todo: refactor this because it's hideous
    let sparseData: any =
      bottleData[0].bottle_tag === "Rogue1"
        ? bottleData
            .filter((tag, i) => {
              if (tag.status === "TRACK" && i !== bottleData.length - 1) {
                return i % 5 === 0;
              } else {
                return true;
              }
            })
            .sort((a, b) =>
              a.status === "TRACK" ? -1 : b.status === "TRACK" ? 1 : 0
            )
            .reverse()
        : bottleData;

    sparseData = convertToGeoJSON(sparseData);

    if (bottleData[0].bottle_tag === "Rogue1" && bottleData.length === 1) {
      sparseData.features[sparseData.features.length - 1].properties["last"] =
        true;
    }

    const customMarker = (point: any, latlng: any) => {
      // @ts-ignore
      const bottleProps = tagMap[point.properties.bottle_tag];
      const status = point.properties.status;

      let marker = L.circleMarker(latlng, {
        radius: 8,
        fillColor:
          status === "DEPLOY" && !point.properties.last
            ? colors.green
            : status === "STOP" || point.properties.last
            ? colors.red
            : bottleProps.color,
        color: colors.black,
        weight: 1,
        opacity: 1,
        fillOpacity: 1,
      });

      let popup: L.CircleMarker;
      if (point.properties.speed) {
        popup = marker.bindPopup(`Speed: ${point.properties.speed}`);
      }

      marker.on("mouseover", () => {
        // if (popup) {
        //   popup.openPopup();
        // }
      });

      marker.on("mouseout", () => {
        // if (popup) {
        //   popup.closePopup();
        // }
      });

      // edit marker popup and events
      marker.on("click", () => {
        if (popup) {
          popup.openPopup();
        }
        // if (map.getZoom() >= 13) {
        //   return;
        // }
        // const lats = bottleData.map((d) => {
        //   return parseFloat(d.latitude);
        // });
        // const lngs = bottleData.map((d) => {
        //   return parseFloat(d.longitude);
        // });
        // const bounds = [
        //   [Math.max(...lats), Math.max(...lngs)],
        //   [Math.min(...lats), Math.min(...lngs)],
        // ];
        // map.fitBounds(bounds, { padding: [20, 20], maxZoom: 13 });
      });
      return marker;
    };

    // add lines
    const latlngs = bottleData.map((d) => {
      return [d.latitude, d.longitude];
    });

    // @ts-ignore
    const bottleProps = tagMap[bottleData[0].bottle_tag];

    L.polyline(latlngs, {
      color: colors.black,
      opacity: 1,
      weight: 8,
      smoothFactor: 3.0,
    }).addTo(map);

    L.polyline(latlngs, {
      color: bottleProps.color,
      opacity: 1,
      weight: 5,
      smoothFactor: 3.0,
    }).addTo(map);

    // add markers
    L.geoJSON(sparseData, {
      pointToLayer: customMarker,
    }).addTo(map);
  };

  const renderPoints = useCallback(
    (map) => {
      // add SL to BR
      const line = Rogue1Line.features[0].geometry.coordinates.map((q: any) => {
        return [q[1], q[0]];
      });
      L.polyline(line, {
        color: colors.black,
        opacity: 1,
        weight: 8,
      }).addTo(map);
      L.polyline(line, {
        color: colors.orange,
        opacity: 1,
        weight: 5,
      }).addTo(map);

      // add new data
      if (bottleData.length > 0) {
        // separate bottles by tag
        const splitBottleData = _.groupBy(bottleData, "bottle_tag");
        Object.values(splitBottleData).forEach((group) => {
          const splits = splitByTrack(group);
          splits.forEach((split) => {
            addBottleToMap(map, split);
          });
        });

        const lats = bottleData.map((d: any) => {
          return parseFloat(d.latitude);
        });

        const lngs = bottleData.map((d: any) => {
          return parseFloat(d.longitude);
        });

        const bounds = [
          [Math.max(...lats), Math.max(...lngs)],
          [Math.min(...lats), Math.min(...lngs)],
        ];

        map.flyToBounds(bounds, { padding: [50, 50] });

        // add custom legend
        // @ts-ignore
        const legend = L.control({ position: "bottomright" });

        legend.onAdd = function () {
          const div = L.DomUtil.create("div", "info legend");
          div.innerHTML += `<h4>Active Bottles</h4>`;
          Object.values(splitBottleData)
            .sort((a, b) => {
              // @ts-ignore
              const aProps = tagMap[a[0].bottle_tag];
              // @ts-ignore
              const bProps = tagMap[b[0].bottle_tag];
              return aProps.order - bProps.order;
            })
            .forEach((group) => {
              // @ts-ignore
              const bottleProps = tagMap[group[0].bottle_tag];
              // @ts-ignore
              div.innerHTML += `<div data-tag="${group[0].bottle_tag}" class="legend-item"><i style="background: ${bottleProps.color}"></i> &ndash; ${bottleProps.name}</div>`;
            });
          return div;
        };

        legend.addTo(map);
        const legendItems = document.getElementsByClassName("legend-item");
        for (let i = 0; i < legendItems.length; i++) {
          // @ts-ignore
          const tag = legendItems[i].dataset["tag"];
          // @ts-ignore
          legendItems[i].onclick = () => {
            const data = splitBottleData[tag];
            const lats = data.map((d) => {
              // @ts-ignore
              return parseFloat(d.latitude);
            });
            const lngs = data.map((d) => {
              // @ts-ignore
              return parseFloat(d.longitude);
            });
            const bounds = [
              [Math.max(...lats), Math.max(...lngs)],
              [Math.min(...lats), Math.min(...lngs)],
            ];
            map.getZoom() <= 13
              ? map.fitBounds(bounds, { padding: [20, 20] })
              : map.flyToBounds(bounds, { padding: [20, 20] });
          };
        }
      }
    },
    [bottleData]
  );

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const data = await fetchBottleData();
        setBottleData(data ? data : []);
        setLoading(false);
      } catch (err) {
        setErr("Something went wrong.");
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Map
      data={bottleData}
      err={err}
      loading={loading}
      renderData={renderPoints}
    />
  );
};

export default BottleMap;
